import { AuthenticationManager } from "@core/managers/authentication.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { EtabSignupService } from "@core/services";
import { GETTER_SIGNUP_GET } from "@etab/stores/types";
import { GETTER_TRANSITIONS_GET } from "@core/store/types";
import { ISignup } from "@core/models";
import { ETAB_EVENTS, ETAB_ROUTES } from "@etab/config";
import { EventManager } from "@core/managers/event.manager";
import { mapStores } from "pinia";
import { useCssTransitionsStore } from "@core/store/modules/cssTransitions";
import { useSignupStore } from "@etab/stores/signup";

export const signupMixin = {
  function() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapStores(useCssTransitionsStore, useSignupStore),
    $_signupModel() {
      return this.signupStore[GETTER_SIGNUP_GET];
    },
    $_transition() {
      return this.cssTransitionsStore[GETTER_TRANSITIONS_GET];
    },
  },
  created() {
    this.$ISignup = ISignup;
  },
  methods: {
    $_nextStep({ step } = {}) {
      EventManager.emit(ETAB_EVENTS.STEPS.NEXT_STEP, { step });
    },
    async $_completeCreationProcess({ signupData }) {
      try {
        this.$_startGlobalLoading();
        await EtabSignupService.create({ signupData });

        const login = this.$_signupModel[this.$ISignup.email];
        const password = this.$_signupModel[this.$ISignup.password];
        await this.$_autoLogin({ login, password });
      } catch (error) {
        NotificationsManager.contactEtabSupport();
        throw error;
      } finally {
        this.$_stopGlobalLoading();
      }
    },
    async $_autoLogin({ login, password }) {
      const loginSuccess = await AuthenticationManager.login({ login, password });
      if (loginSuccess) {
        this.$_navigateToCreationSuccessPage();
      } else {
        // RG Signup: there's a problem with auth, we ask the user to log himself in a nice way
        NotificationsManager.success({ message: "ERRORS.@ACCOUNT_CREATED_PLEASE_LOGIN" });
        this.$_navigateToLoginPage();
      }
    },
    $_navigateToCreationSuccessPage() {
      this.$router.push({ name: ETAB_ROUTES.signup.steps.root.name, params: { success: true } });
    },
    $_navigateToLoginPage() {
      this.$router.push({ name: ETAB_ROUTES.auth.login.name });
    },
  },
};
